import { SaveOutlined } from '@ant-design/icons';
import { Button, Space } from 'antd';

import {
  RIGHTS_IS_CREATE,
  RIGHTS_IS_DELETE,
  RIGHTS_IS_EDIT,
  RIGHTS_WORK_SCHEDULES,
} from '@app/constants';
import { useAccessRights, useWindowSize } from '@app/hooks';

import type { NWorkSchedule } from '@pages/WorkSchedule/WorkSchedule.types';

export const ScheduleFooter: NWorkSchedule.Footer = ({
  saveChangingSchedules,
  cancelChanges,
}) => {
  const { innerWidth } = useWindowSize();
  const { hasUserRight: creationInPresentAndFeature } = useAccessRights(
    RIGHTS_WORK_SCHEDULES,
    RIGHTS_IS_CREATE
  );

  const { hasUserRight: deletionInPresentAndFeature } = useAccessRights(
    RIGHTS_WORK_SCHEDULES,
    RIGHTS_IS_DELETE
  );
  const { hasUserRight: editionInPresentAndFeature } = useAccessRights(
    RIGHTS_WORK_SCHEDULES,
    RIGHTS_IS_EDIT
  );

  return (
    <footer className="footer-both-modes">
      <div className="global-container">
        <div className="cancel-container">
          <Button
            className="footer-button"
            size={'small'}
            type="default"
            onClick={cancelChanges}
            data-testid="cancel"
            disabled={
              !creationInPresentAndFeature &&
              !deletionInPresentAndFeature &&
              !editionInPresentAndFeature
            }
          >
            Отменить
          </Button>
        </div>

        <div className="save-container">
          {innerWidth > 755 ? (
            <Space size="small">
              <div className="save-attention__container">
                <p className="save-attention" data-testid="tooltip-text">
                  Без нажатия на эту кнопку изменения не сохранятся
                </p>
              </div>
              <Button
                className="footer-button"
                size={'small'}
                type="primary"
                icon={<SaveOutlined />}
                onClick={saveChangingSchedules}
                data-testid="save"
                disabled={
                  !creationInPresentAndFeature &&
                  !deletionInPresentAndFeature &&
                  !editionInPresentAndFeature
                }
              >
                Сохранить
              </Button>
            </Space>
          ) : (
            <Button
              className="footer-button"
              size={'small'}
              type="primary"
              icon={<SaveOutlined />}
              onClick={saveChangingSchedules}
              data-testid="save"
              disabled={
                !creationInPresentAndFeature &&
                !deletionInPresentAndFeature &&
                !editionInPresentAndFeature
              }
            >
              Сохранить
            </Button>
          )}
        </div>
      </div>
    </footer>
  );
};
